import { Row, RowRendererProps } from 'react-data-grid';
import React from 'react';
import { Notification } from 'types/notification.types';
import { BodyRow } from 'app/components/ChakraTableList';

interface NotificationsListRowRendererProps {
  notification: Notification;
  rowRendererProps: RowRendererProps<BodyRow>;
  markNotificationAsOld: (guid: string) => void;
}

export const NotificationsListRowRenderer = ({
  notification,
  rowRendererProps,
  markNotificationAsOld,
}: NotificationsListRowRendererProps) => {
  return (
    <Row
      onMouseEnter={() => {
        const isInteractive = Boolean(notification.rel);
        if (!isInteractive && markNotificationAsOld && notification.new) {
          markNotificationAsOld(notification.guid);
        }
      }}
      {...rowRendererProps}
    />
  );
};
